<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <app-drawer class="app--drawer" v-if="$route.name !== 'Geolocation'"> </app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>
           <!-- App Footer -->
          <v-footer height="auto" class="white pa-3 app--footer">
            <span class="caption">knower.io&copy; {{ new Date().getFullYear() }}</span>
            <v-spacer></v-spacer>
            <!-- <span class="caption mr-1"> Make With Love </span> <v-icon color="pink" small>favorite</v-icon> -->
          </v-footer>
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
      </v-app>
    </template>
    <template v-else-if="$route.meta.survey">
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show" multi-line>
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <div class="wrapper-loading" v-if="loading">
      <div class="text-xs-center">
        <v-progress-circular indeterminate :size="100" color="primary"></v-progress-circular>
      </div>
    </div>
  </div>
</template>
<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import menu from '@/api/menu';
import AppEvents from './event';
import { mapGetters } from 'vuex';

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader
  },
  data: () => ({
    expanded: true,
    rightDrawer: false
  }),
  computed: {
    ...mapGetters(['loading', 'snackbar']),
  },
  created () {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },
  mounted () {
    const favicon = document.getElementById('favicon');
    favicon.href = process.env.FAVICON;
    document.title = process.env.APP_NAME;
  }
};
</script>
<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}
.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}
.wrapper-loading{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, .5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-progress-circular{
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue